require('./operational-support.scss');
import {submitMailCta} from "../utils";

$(() => {
    submitMailCta();

    var swiper = new Swiper(".mySwiper", {
        cssMode: true,
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        mousewheel: true,
        keyboard: true,
        breakpoints: {
            900: {
                slidesPerView: 2,
            }
        }
    });

    //lazy load youtube iframes
    const lazyLoadIframe = ({ iframeAnchorElement, $iframe, src, rootMargin }) => {
        const iframeOptions = {rootMargin: rootMargin, threshold: 0};
        if (!iframeAnchorElement) {
            return;
        }

        let iframeIsVisible = false;

        const iframeObserver = new IntersectionObserver(event => {
            iframeIsVisible = event[0].isIntersecting;

            if (iframeIsVisible) {
                $iframe.attr('src', src);
                iframeObserver.disconnect();
            }
        }, iframeOptions);

        iframeObserver.observe(iframeAnchorElement);
    }

    const lazyLoadYoutubeContent = (ytiframe, src, rootMargin) => lazyLoadIframe({
        iframeAnchorElement: $(`#${ytiframe}`)[0],
        $iframe: $(`iframe#${ytiframe}`),
        src,
        rootMargin
    });

    $(() => {
        // English version
        lazyLoadYoutubeContent('iframe1', 'https://www.youtube.com/embed/2aMtUB_usnw', '0px');
        lazyLoadYoutubeContent('iframe2', 'https://www.youtube.com/embed/O6S98hLxC4w', '0px');
        lazyLoadYoutubeContent('iframe3', 'https://www.youtube.com/embed/zrGrSIjPpKM ','0px');
        // Spanish version
        lazyLoadYoutubeContent('iframe4', 'https://www.youtube.com/embed/dc6vHWk_AJE', '0px');
    });
});
